{
  "title": "การเชื่อมต่อมาร์เก็ตเพลส",
  "subtitle": "เชื่อมต่อบัญชีผู้ขายของมาร์เก็ตเพลสเพื่อให้คำสั่งซื้อ สต๊อก และการคืนสินค้าซิงค์กันโดยอัตโนมัติ",
  "error": "โหลดการเชื่อมต่อมาร์เก็ตเพลสไม่สำเร็จ",
  "retry": "ลองใหม่",
  "mp_shopee": "Shopee",
  "mp_tiktok": "TikTok",
  "mp_lazada": "Lazada",
  "status_active": "เชื่อมต่อแล้ว",
  "status_not_connected": "ยังไม่เชื่อมต่อ",
  "status_expired": "หมดอายุ",
  "status_revoked": "ถูกเพิกถอน",
  "status_expiring_soon": "ใกล้หมดอายุ",
  "lbl_shop": "ร้านค้า: {{name}}",
  "lbl_shop_id": "รหัสร้านค้า: {{id}}",
  "lbl_shop_code": "รหัสร้านค้า TikTok: {{code}}",
  "lbl_connected_at": "เชื่อมต่อเมื่อ {{date}}",
  "warn_refresh_expiring": "Refresh token จะหมดอายุ {{date}} — กรุณาเชื่อมต่อใหม่ก่อนหมดอายุ",
  "warn_attention": "ต้องดำเนินการ: {{detail}}",
  "sync_paused": "การซิงค์คำสั่งซื้อหยุดชั่วคราว",
  "reason_revoked": "{{marketplace}} ปฏิเสธข้อมูลรับรองของเราเมื่อ {{date}} ซึ่งมักเกิดจากรหัสผ่านของผู้ขายถูกเปลี่ยน กรุณาเชื่อมต่อใหม่เพื่อให้การซิงค์ทำงานต่อ",
  "reason_expired": "การเชื่อมต่อนี้หมดอายุเมื่อ {{date}} กรุณาเชื่อมต่อใหม่เพื่อให้การซิงค์ทำงานต่อ",
  "lbl_last_error": "รายละเอียด: {{detail}}",
  "btn_connect": "เชื่อมต่อ",
  "btn_reconnect": "เชื่อมต่อใหม่",
  "toast_connect_failed": "เริ่มการเชื่อมต่อไม่สำเร็จ — กรุณาลองอีกครั้ง",
  "toast_oauth_success": "เชื่อมต่อมาร์เก็ตเพลสสำเร็จ",
  "toast_oauth_error": "เชื่อมต่อมาร์เก็ตเพลสไม่สำเร็จ",
  "status_disconnected": "Disconnected",
  "btn_disconnect": "Disconnect",
  "lbl_disconnected_at": "Disconnected {{date}}",
  "toast_disconnect_success": "Shop disconnected",
  "toast_disconnect_failed": "Failed to disconnect — please try again",
  "disconnect": {
    "title": "Disconnect {{shop}}?",
    "warning": "After disconnecting, Atlas will stop fetching new orders from {{shop}}. Orders placed on {{marketplace}} after this point will NOT reach the warehouse. Open orders already in Atlas continue as normal.",
    "counts": "{{openOrders}} open orders and {{activePromotions}} active promotions belong to this shop. They are kept exactly as they are.",
    "confirm": "Disconnect",
    "cancel": "Keep connected"
  },
  "connect": {
    "replace_title": "Replace the active shop on {{marketplace}}?",
    "replace": "{{current}} is currently active on {{marketplace}}. Connecting a new shop will disconnect it. Its orders and promotions are kept.",
    "confirm": "Continue",
    "cancel": "Cancel"
  },
  "listings": {
    "line": "ผูกข้อมูลแล้ว {{mapped}} · ยังไม่ผูก {{unmapped}} · ซ้ำ {{duplicate}}",
    "refreshed": "รีเฟรชแล้ว {{rel}}",
    "never": "ยังไม่เคยรีเฟรช",
    "view": "ดู",
    "refresh": "รีเฟรชตอนนี้",
    "multi_wh": "{{n}} คลังสินค้า — ระงับการส่งสต๊อก",
    "title": "รายการประกาศขาย — {{mkp}}",
    "toast_refresh_success": "รีเฟรชแล้ว: ผูกข้อมูลแล้ว {{mapped}} · ยังไม่ผูก {{unmapped}} · ซ้ำ {{duplicate}}",
    "error": "โหลดข้อมูลสรุปรายการประกาศขายไม่สำเร็จ: {{detail}}",
    "summary_line": "ผูกข้อมูลแล้ว {{mapped}}",
    "col": {
      "seller_sku": "seller_sku",
      "status": "สถานะ",
      "problem": "ปัญหา"
    },
    "problem": {
      "unmapped": "แก้ไข seller_sku ใน Seller Center แล้วกด รีเฟรช",
      "duplicate": "สร้าง SKU ใน Atlas แล้วกด รีเฟรช"
    },
    "ids_tooltip": "สินค้า {{productId}} / ตัวเลือกสินค้า {{variantId}}",
    "status": {
      "mapped": "ผูกข้อมูลแล้ว",
      "unmapped": "ยังไม่ผูกข้อมูล",
      "duplicate": "ข้อมูลซ้ำ"
    }
  },
  "btn_switch": "เปลี่ยนร้านค้า",
  "lbl_shop_unnamed": "ร้านค้าไม่มีชื่อ",
  "lbl_previous_one": "การเชื่อมต่อก่อนหน้า {{count}} รายการ",
  "lbl_previous_other": "การเชื่อมต่อก่อนหน้า {{count}} รายการ",
  "col": {
    "marketplace": "มาร์เก็ตเพลส",
    "shop": "ร้านค้า",
    "status": "สถานะ",
    "listings": "รายการประกาศขาย",
    "refreshed": "รีเฟรชล่าสุด",
    "actions": "การดำเนินการ"
  }
}
